<div (click)="openPopup($event)" tappable>
  <span *ngIf="value">{{ value | CompanyLocalized : 'dateFormat' }}</span>
  <span *ngIf="!value">{{ placeholder }}</span>
</div>
